import courseData from "./course.json";
import type { Course } from "../types";

export const activeCourse = courseData as unknown as Course;
